import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';

class ConsumiFeModalController implements ng.IController {

  static $inject: string[] = [
    '$rootScope',
    '$scope',
    'ArchiSmallServices'
  ];

  private close: any;

  constructor(
    private $rootScope: any, // ng.IRootScopeService,
    private $scope: any, // ng.IScope,
    private ArchiSmallServices: ArchiSmallServices
  ) {
    $scope.year = new Date().getFullYear();
    $scope.isUsagePercentage = true;
    $scope.isUsagePercentageThresholdExceeded = () => {
      $scope.isUsagePercentage = false;
      $scope.thresholdExceeded = ($rootScope.storageUsage.invoicesSent + $rootScope.storageUsage.invoicesReceived) - $rootScope.storageUsage.invoiceslicenseUser;
    };

    $scope.options = {
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            const label = data.labels[tooltipItem.index] || '';
            const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return `${label}: ${value} %`;
          }
        }
      }
    };

    if (($rootScope.storageUsage.invoicesSent + $rootScope.storageUsage.invoicesReceived) < $rootScope.storageUsage.invoiceslicenseUser) {
      $scope.isUsagePercentage = true;
      $scope.sumInvoices = $rootScope.storageUsage.invoicesSent + $rootScope.storageUsage.invoicesReceived;
      $scope.showAlertWarning = $scope.sumInvoices > ($rootScope.storageUsage.invoiceslicenseUser * 0.8);
    } else {
      $scope.isUsagePercentageThresholdExceeded();
    }
    // $scope.options = { tooltipTemplate: '<%if (label){%><%=label%> <%}%>' };
    //    circumference: 25};
    $scope.close = () => {
      this.close();
    };

    $scope.getModulo = (index: any) => {
      return index % 2;
    };

    $scope.consumiData = [
      {'class': 'consumi-fattura-bgrd', 'label': 'Fatture Inviate', 'invoices': $rootScope.storageUsage.invoicesSent},
      {
        'class': 'consumi-conserva-bgrd',
        'label': 'Fatture Ricevute',
        'invoices': $rootScope.storageUsage.invoicesReceived
      },
      {
        'class': 'consumi-free-bgrd',
        'label': 'Fatture rimanenti da profilo',
        'invoices': $rootScope.storageUsage.invoicesRemainingToSend
      },
    ];
  }
}

export const ConsumiFeModalComponent: ng.IComponentOptions = {
  template: require('./consumi-fe-modal.html'),
  controller: ConsumiFeModalController,
  bindings: {
    close: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/consumi-fe-modal/consumi-fe-modal.ts